export const getNotificationStatusLabel = (status: string | undefined) => {
    const statusMap: Record<string, { label: string; color: string }> = {
      "-1": { label: "Failed / Rejected", color: "text-red-500" },
      "0": { label: "Pending", color: "text-yellow-600" },
      "1": { label: "Processed", color: "text-green-500" },
    };
  
    return status ? statusMap[status] || { label: "Unknown Status", color: "text-gray-500" } 
                  : { label: "No Status Available", color: "text-gray-400" };
  };